import { useState, type FormEvent } from "react";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import { useAuth } from "../../hooks/auth";
import refreshToken from "../../utils/refreshToken";
import { resolvePropertyNavigationId } from "../../utils/resolvePropertyNavigationId";
import { FLOW_TEXT_INPUT_BASE } from "../../styles/twDesignPrimitives";

export function PropertiesCodeSearchField() {
  const history = useHistory();
  const { access_token, dateToExpires } = useAuth();
  const [code, setCode] = useState("");
  const [resolving, setResolving] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) return;

    const requestedId = Number(trimmed);
    if (!Number.isFinite(requestedId) || requestedId <= 0) {
      history.push(`/property/${trimmed}`);
      return;
    }

    setResolving(true);
    try {
      const token = await refreshToken(dateToExpires, access_token);
      api.defaults.headers.authorization = `Bearer ${token ?? access_token}`;
      const targetId = await resolvePropertyNavigationId(api, requestedId);
      history.push(`/property/${targetId}`);
    } catch {
      history.push(`/property/${trimmed}`);
    } finally {
      setResolving(false);
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex min-w-[200px] shrink-0 flex-col gap-1 text-left text-xs font-medium text-slate-600 md:max-w-[220px]"
    >
      Código do imóvel
      <input
        className={`${FLOW_TEXT_INPUT_BASE} !font-[inherit]`}
        autoComplete="off"
        value={code}
        onChange={(event) => setCode(event.target.value)}
        type="text"
        placeholder="Código do imóvel"
        disabled={resolving}
      />
    </form>
  );
}
